/**
 * Overridable method signatures per domain.
 * Mirrors the definitions in @clientos/types — keep in sync.
 */

export type SessionOverridableMethods = {
  isLoggedIn: () => boolean;
  refresh: (refreshParameterType?: Record<string, unknown>) => Promise<void>;
};

export type AuthProviderOverridableMethods = {
  getAccessToken: (forceRefresh?: boolean) => Promise<string>;
};

export type OverridableMethodsMap = {
  session: SessionOverridableMethods;
  authProvider: AuthProviderOverridableMethods;
};

/**
 * Override methods type for use in `registerFromType`.
 * Each API name key is optional, and each method within is optional.
 */
export type OverrideMethodsType = {
  [K in keyof OverridableMethodsMap]?: {
    [M in keyof OverridableMethodsMap[K]]?: OverridableMethodsMap[K][M];
  };
};

/**
 * Internal store type — loose record used for the runtime store.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type OverrideStoreType = Record<
  string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Record<string, (...args: unknown[]) => unknown>
>;

export const OVERRIDE_TO_API_KEY_MAP = {
  session: 'session',
  authProvider: 'authProvider'
} as const;

export const OVERRIDE_METHOD_NAME_MAP = {
  session: {
    isLoggedIn: 'isLoggedIn',
    refresh: 'refreshToken'
  },
  authProvider: {
    getAccessToken: 'getAccessToken'
  }
} as const;
